import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _createAreaUserInitQuery = (id: string) => ({
  areas_by_pk: params(
    { id: rawString(id) },
    {
      name: types.string,
    },
  ),
});

type X = Unpacked<typeof _createAreaUserInitQuery>
export type Area = X['areas_by_pk'];

export const createAreaUserInitQuery = (id: string) => gql`${query(_createAreaUserInitQuery(id))}`;
